/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { NumericSearch } from './NumericSearch';
import {
    NumericSearchFromJSON,
    NumericSearchFromJSONTyped,
    NumericSearchToJSON,
} from './NumericSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface FormateurSearch
 */
export interface FormateurSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurSearch
     */
    searchNom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurSearch
     */
    searchPrenom?: TextSearch;
    /**
     * 
     * @type {NumericSearch}
     * @memberof FormateurSearch
     */
    contrat?: NumericSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurSearch
     */
    localiteCentre?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof FormateurSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof FormateurSearch
     */
    jure?: BooleanSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurSearch
     */
    anneeAcademique?: TextSearch;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormateurSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FormateurSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormateurSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FormateurSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FormateurSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FormateurSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FormateurSearch interface.
 */
export function instanceOfFormateurSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurSearchFromJSON(json: any): FormateurSearch {
    return FormateurSearchFromJSONTyped(json, false);
}

export function FormateurSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchNom': !exists(json, 'searchNom') ? undefined : TextSearchFromJSON(json['searchNom']),
        'searchPrenom': !exists(json, 'searchPrenom') ? undefined : TextSearchFromJSON(json['searchPrenom']),
        'contrat': !exists(json, 'contrat') ? undefined : NumericSearchFromJSON(json['contrat']),
        'localiteCentre': !exists(json, 'localiteCentre') ? undefined : TextSearchFromJSON(json['localiteCentre']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'jure': !exists(json, 'jure') ? undefined : BooleanSearchFromJSON(json['jure']),
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : TextSearchFromJSON(json['anneeAcademique']),
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FormateurSearchToJSON(value?: FormateurSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchNom': TextSearchToJSON(value.searchNom),
        'searchPrenom': TextSearchToJSON(value.searchPrenom),
        'contrat': NumericSearchToJSON(value.contrat),
        'localiteCentre': TextSearchToJSON(value.localiteCentre),
        'actif': BooleanSearchToJSON(value.actif),
        'jure': BooleanSearchToJSON(value.jure),
        'anneeAcademique': TextSearchToJSON(value.anneeAcademique),
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

